import { showToast } from '@/components/ui/sonner';
import { authState } from '@/vars/auth';
import { ApolloClient, InMemoryCache, Observable, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpUrl = import.meta.env.VITE_BASE_URL;
const httpLink = createHttpLink({
  uri: httpUrl,
});

const logoutUser = () => {
  localStorage.clear();
  client.clearStore().then(() => {
    authState({ authenticated: false, loading: false });
  });
  showToast({
    message: 'Session has expired. Please login back to continue',
    variant: 'warning',
  });
};

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, operation, forward, networkError }) => {
  if (graphQLErrors?.[0]?.extensions?.code === 'UNAUTHENTICATED') {
    return new Observable((observer) => {
      fetch(httpUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: `mutation GenerateAccessToken($refreshToken: String!) {
              generateAccessToken(refreshToken: $refreshToken){
                token
              }
            }`,
          variables: {
            refreshToken: localStorage.getItem('refreshToken'),
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          operation.setContext(({ headers = {} }) => ({
            headers: {
              ...headers,
              authorization: `Bearer ${data.data.generateAccessToken.token}`,
            },
          }));
          localStorage.setItem('accessToken', data.data.generateAccessToken.token);
        })
        .then(() => {
          const subscriber = {
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          };
          forward(operation).subscribe(subscriber);
        })
        .catch(() => {
          logoutUser();
          observer.error('Failed to fetch new access token');
        });
    });
  }
  if (networkError) {
    console.log('network error: ', networkError);
  }
});

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});

export default client;
